import { useHistory, useLocation } from 'react-router';
import { useQuery } from '@apollo/client';
import { GET_FILTERED_EQUIPAMENTOS, KEY } from '../../Graphql/QUERIES';
import TopBar from '../../components/TopBar';
import { useStyles } from './styles';
import PageContainer from '../../components/PageContainer';
import { Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
import { useTheme } from '../../hooks/useTheme';
import { useEffect } from 'react';
import BottomBar from '../../components/BottomBar';
import { colors } from '../../colors';


function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

function SearchResult() {
  const classes = useStyles();
  const { changeTheme } = useTheme();
  let query = useQueryParams();
  let history = useHistory();
  const search = query.get("search");
  const r = query.get("r");
  const d = query.get("d");
  const e = query.get("e");
  const { loading, error, data } = useQuery(GET_FILTERED_EQUIPAMENTOS, {
    variables: {
      token: KEY,
      distritoId: parseInt(d),
      tipoEquipamento: parseInt(e),
      tipoRede: parseInt(r),
      tipoServico: -1,
      txtPesquisa: search,
    },
  })

  useEffect(() => {
    changeTheme();
  }, [])
  
  function labelColor(label) {
    switch (label) {
      case "Público":
        return colors.public;
      case "Privado":
        return colors.private;
      default:
        return colors.default
    }
  }

  function handleChangePage(redeId, serviceId, id) {
    history.push(`redes/${redeId}/${serviceId}/${id}`)
  }

  if (loading) return(
    <>
      <TopBar>
        <Typography variant="h1">
          Carregando...
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography>
            Carregando...
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  );
  if (error) return(
    <>
      <TopBar>
        <Typography variant="h1">
          Erro
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography>
            Ops! Parece que ocorreu um erro.
            Tente novamente mais tarde.
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  )
  return(
    <>
      <TopBar>
        <Typography variant="h1">
          Resultado
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          {data.EquipamentoFilter.length === 0 ? (
            <Typography>
              Não foram encontrados nenhum resultado de busca.
            </Typography>
          ) : (
            data.EquipamentoFilter.map(eqp => {
              return(
                <Card 
                key={eqp.ID}
                className={classes.card} 
                onClick={() => handleChangePage(eqp.TipoRedeId, eqp.TipoServicoId, eqp.ID)}
              >
                <CardActionArea>
                  <CardContent>
                    <Typography 
                      variant="h2" 
                      color="textPrimary" 
                      className={classes.equipment}
                    >
                      {eqp.Nome}
                    </Typography>
                    <Typography variant="body1" className={classes.info}>
                      Mais informações
                    </Typography>
                    {eqp.NATUREZA_JURIDICA && (
                      <Card className={classes.label} style={{backgroundColor: labelColor(eqp.NATUREZA_JURIDICA)}}>
                        <CardContent>
                          <Typography>
                            {eqp.NATUREZA_JURIDICA.substring(0,10)}
                          </Typography>
                        </CardContent>
                      </Card>
                    )}
                  </CardContent>
                </CardActionArea>
              </Card>
              )
            })     
          )}
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  );
}

export default SearchResult;